module.exports = __webpack_public_path__ + "static/default-search-0129eeb82f6ef44a9ee2d58fe8b7deb7.png";